import SampleReportView from "@/components/samples/SampleReportView";
import { CHARGE_REPORT } from "@/data/sample-reports";

const ChargeSample = () => <SampleReportView report={CHARGE_REPORT} />;

export default ChargeSample;
